export default `
  #graphql
  mutation amSocialLoginUnlinkAccount($type: String!) {
    amSocialLoginUnlinkAccount(type: $type) {
      isSuccess
      message
    }
  }
`;
